// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__17NTR","header":"Messages_header__3E2o7"};